function injectStyle (context) {
  require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/tarball/node_modules/bourbon/core/_bourbon.scss\",\"/tarball/node_modules/node-normalize-scss/_normalize.scss\",\"/tarball/node_modules/material-colors/dist/colors.scss\",\"/tarball/src/styles/_variables.scss\",\"/tarball/src/styles/_mixins/_mixins.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PatientList.vue")
}
/* script */
export * from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PatientList.vue"
import __vue_script__ from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PatientList.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-67abe044\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug&optionsId=0!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PatientList.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports
